export default __webpack_public_path__ + "static/media/0206.322e8cdf.jpg";